import { Component, Input } from '@angular/core';
import { Controparte } from '../../../models/controparte';

@Component({
    selector: '[controparte_anagrafica_view]',
  templateUrl: 'controparti-anagrafica-view.component.html',
})

export class  ContropartiAnagraficaViewComponent {
  @Input()
  controparte: Controparte;
  @Input() hideOtherData: boolean;
}
